import classNames from 'classnames'
import formatDateInLocalTimezone from '@insided/shared/utils/dateFormatting'

interface Props {
  updatedBy: string
  updatedAt: string
  isLoading: boolean
}

const TeamNotesLastEdited = ({ updatedBy, updatedAt, isLoading }: Props) => (
  <div>
    <div className={classNames(
      'team-notes__metadata-last-edited', {
        'team-notes__metadata-last-edited--is-loading': isLoading
      })}
    >
      Last edited by <span className='team-notes__metadata-author'>{updatedBy}</span> on {formatDateInLocalTimezone(updatedAt)}
    </div>
  </div>
)

export default TeamNotesLastEdited
